import AgGridYesNoFilter from '@components/ag-grid-helpers/AgGridYesNoFilter'
import { getColDefs } from './colDefHelpers'

export const gridOptions = {
  computed: {
    gridOptions() {
      if (!this.columns) return

      return {
        columnDefs: getColDefs.call(this, this.columns),
        context: {
          actions: [
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.deleteArticle,
              color: 'faded'
            }
          ]
        },
        defaultColDef: {
          floatingFilter: true,
          filter: 'agTextColumnFilter',
          suppressMenu: true,
          floatingFilterComponentParams: {
            debounceMs: 800
          }
        },
        frameworkComponents: {
          AgGridYesNoFilter
        },
        cacheBlockSize: 40,
        pagination: false,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        domLayout: 'normal'
      }
    }
  }
}
